import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Logo from "../../assets/images/logo/01.png";


const Header = () => {
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);

    return (
        <>
            <section id="header" className="header-main-block">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-2 col-lg-2 col-md-2">
                            <div className="header-logo">
                                <Link to="/" title="">
                                    <img src={Logo} className="img-fluid" alt="Logo" />
                                </Link>
                            </div>
                        </div>
                        <div className="col-xl-7 col-lg-6 col-md-7">
                            <div className="header-search-block">
                                <div className="input-group">
                                    <button
                                        className="btn dropdown-toggle"
                                        type="button"
                                        onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                                    >
                                        All <i className="flaticon-down-arrow" />
                                    </button>
                                    {isDropdownOpen && (
                                        <ul className="dropdown-menu show">
                                            <li><Link className="dropdown-item" to="#">Fashion</Link></li>
                                            <li><Link className="dropdown-item" to="#">Accessories</Link></li>
                                            <li><Link className="dropdown-item" to="#">Electronics</Link></li>
                                        </ul>
                                    )}
                                    <input type="text" className="form-control" placeholder="Search for products..." />
                                    <Link to="#" className="search-icon">
                                        <i className="flaticon-search-interface-symbol" />
                                    </Link>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-3 col-lg-4 col-md-3">
                            <div className="header-right-block">
                                <ul>
                                    <li>
                                        <div className="user-icon-block">
                                            <div className="user-icon">
                                                <i className="flaticon-user" />
                                            </div>
                                            <div className="user-dtl">
                                                <span>Sign In</span>
                                                <h6 className="user-title">Account</h6>
                                            </div>
                                        </div>
                                    </li>
                                    <li className="wishlist-icon-block">
                                        <Link to="/wishlist" title="">
                                            <i className="flaticon-love" />
                                            <span className="icon-badge">1</span>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="/cart" title="">
                                            <div className="cart-icon-block">
                                                <div className="cart-icon">
                                                    <i className="flaticon-shopping-cart" />
                                                    <span className="icon-badge">0</span>
                                                </div>
                                                <div className="cart-dtl">
                                                    <span>Total</span>
                                                    <h6 className="cart-price">$0.00</h6>
                                                </div>
                                            </div>
                                        </Link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>

    );
}

export default Header;
